import { takeLatest, takeEvery, call, put, delay } from 'redux-saga/effects';
import Type from '../../actions';
import * as api from '../../../server';
import { message } from 'antd';
import {
  GET_LOSTPROVIDERTYPEDICT,
  GET_LSTPROVIDERTYPEDICT,
  POST_PAYMENT_SUBMIT,
  SET_LOSTPROVIDERTYPEDICT, SET_LOSTPROVIDERTYPEDICTCASEPOOL
} from "../../actions/actionTypes";
import Logs from "@utils/Logs";

// get详情信息
export function* getDetail(action) {
  try {
    const { path, systemNum, cardType, statusType } = action;

    const res = yield call(api.getDetail, path, systemNum, cardType);

    yield put({ type: Type.SET_DETAIL, statusType, systemNum, cardType, content: res })
  } catch (error) {
    console.error(error)
  }
}

export function* getDetailRequest() {
  yield takeEvery(Type.GET_DETAIL, getDetail)
}

//结案登记
export function* closingRegt(action) {
  try {
    const res = yield call(api.closingRegt, action.params, action.path);
    if (res.status === 0) {
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb);
    } else {
      const { cbF = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cbF, res.msg);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* closingRegtRequest() {
  yield takeLatest(Type.GET_CLOSINGREGTS, closingRegt)
}

// post详情操作
export function* postDetailSubmit(action) {
  try {
    const { url, param, showModal, cb = window.noop } = action;
    const res = yield call(api.postDetailSubmit, url, param);
    const msg = res.des || res.msg
    if (res.status === 0 || res.status === 2000) {
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb, msg, 'success', res.docList)
      if (!showModal) {
        message.success('保存成功')
      }
    } else {
      yield put({ type: 'HIDE_LOADING' })
      if (showModal) {
        yield call(cb, msg, 'error')
      } else {
        message.error(msg)
      }
    }
  } catch (error) {
    console.error(error)
  }
}

export function* postDetailSubmitRequest() {
  yield takeEvery(Type.POST_DETAIL_SUBMIT, postDetailSubmit)
}

//新增自动协查找人
export function* postAutomaticSubmitRequest() {
  yield takeEvery(Type.POST_AUTOMATIC_SUBMIT, postAutomaticSubmit)
}

export function* postAutomaticSubmit(action) {
  try {
    const { url, param, showModal, cb = window.noop } = action;
    const res = yield call(api.postAutomaticSubmit, url, param);
    const msg = res.des || res.msg
    if (res.status === 0 || res.status === 2000) {
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb, msg, 'success', res.docList ?? [])
      if (!showModal) {
        message.success(msg)
      }
    } else {
      yield put({ type: 'HIDE_LOADING' })
      if (showModal) {
        yield call(cb, msg, 'error')
      } else {
        message.error(msg)
      }
    }
  } catch (error) {
    console.error(error)
  }
}

//回款登记
export function* postPaymentSubmit(action) {
  try {
    const { url,param,fileList,uploadTime, again,systemNum,cb=window.noop} = action;
    const fileName = fileList.length > 0 ? fileList[0].name : '';
    const res = yield call(api.postPaymentSubmit, url, {
      ...param,
      uploadTime,
      fileType: 1,
      fileName,
      resType: 2,
      systemNum
    });
    let { status } = res;
    if(status === 1){
      yield put({ type: 'HIDE_LOADING' })
      yield call(again)
    }
    if (res.status === 0) {
      if(fileName !== ''){
        let formData = new FormData();
        fileList.map(file =>{
          formData.append("file", file);
        });
        const response = yield call(api.postPaymentFile, url, res.resId, formData)
        if (response.status === 0){
          message.success(response.des);
          yield put({ type: 'HIDE_LOADING' })
          yield call(cb)
        } else {
          message.error(response.des)
        }
      } else {
        message.success('提交成功');
        yield put({ type: 'HIDE_LOADING' })
        yield call(cb)
      }
    }

  }catch (error) {
    console.error(error)
  }

}

export function* postPaymentRequest() {
  yield takeEvery(Type.POST_PAYMENT_SUBMIT, postPaymentSubmit)
}
//回款登记修改
export function* postPaymentSubmitUpdate(action) {
  const { url,param,fileList,uploadTime, again,systemNum,cb=window.noop} = action
  const fileName = fileList.length > 0 ? fileList[0].name : '';
  try {
    const res = yield call(api.postPaymentSubmitUpdate, url, {
      ...param,
      fileList,
      uploadTime,
      fileType: 1,
      fileName,
      resType: 2,
      systemNum
    });
    let { status } = res;
    if(status === 1){
      yield put({ type: 'HIDE_LOADING' })
      yield call(again)
    }
    if (res.status === 0) {
      if(fileName !== ''){
        let formData = new FormData();
        fileList.map(file =>{
          formData.append("file", file);
        });
        const response = yield call(api.postPaymentFile, url, res.resId, formData)
        if (response.status === 0){
          message.success(response.des);
          yield put({ type: 'HIDE_LOADING' })
          yield call(cb)
        } else {
          message.error(response.des)
        }
      } else {
        message.success('修改成功');
        yield put({ type: 'HIDE_LOADING' })
        yield call(cb)
      }
    }

  } catch (error) {
    console.error(error)
  }
}

export function* postPaymentSubmitUpdateRequest() {
  yield takeLatest(Type.POST_PAYMENT_SUBMITUPDATE, postPaymentSubmitUpdate)
}

// 更新调解信息参数
export function* setMediationParam(action) {
  try {
    const { params, path } = action;
    const res = yield call(api.setMediationParam, params, path);
    if (res.status === 0) {
      message.success(res.des)
    } else {
      message.error(res.des)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* setMediationParamRequest() {
  yield takeLatest(Type.POST_EXTRA_MEDIATION, setMediationParam)
}

//电子卷宗打印
export function* pdfConversion(action) {
  try {
    const res = yield call(api.pdfConversion, action.params, action.systemNum, action.path);
    if (res) {
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb, res.resId);
    }
  } catch (error) {
    console.error(error)
  }
  yield put({ type: 'HIDE_LOADING' })
}

export function* pdfConversionRequest() {
  yield takeLatest(Type.GET_PDFCONVERSION, pdfConversion)
}

//文书审核
export function* checkRes(action) {
  try {
    const res = yield call(api.checkRes, action.params, action.resID, action.path);
    if (res) {
      const { cb = window.noop } = action;
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* checkResRequest() {
  yield takeLatest(Type.GET_CHECKRES, checkRes)
}

export function* deleteFile(action) {
  try {
    const res = yield call(api.deleteFile, action.url, action.path);
    if (res) {
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* deleteFileRequest() {
  yield takeLatest(Type.GET_DELETEFILE, deleteFile)
}

// 协查找人获取
export function* getLostPhone(action) {
  try {
    const { path, repairId, cb = window.noop } = action;
    const params = { repairId };
    const res = yield call(api.getLostPhone, path, params);
    if (res.status === 2000) {
      yield put({ type: 'HIDE_LOADING' })
      message.success(res.des)
      yield call(cb)
    } else {
      yield put({ type: 'HIDE_LOADING' })
      message.error(res.des)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* getLostPhoneRequest() {
  yield takeLatest(Type.GET_LOST_PHONE, getLostPhone)
}

// 批量下载
export function* downloadEle(action) {
  try {
    const { path, param } = action;
    const result = yield call(api.downloadEle, path, param);
    yield put({ type: 'HIDE_LOADING' })
    if (result.status === 0) {
      message.success(result.des);
      window.open(result.url || result.resId)
    }
  } catch (error) {
    console.error(error)
  }
}


export function* downloadEleRequest() {
  yield takeLatest(Type.DOWNLOAD_ELE, downloadEle)
}

// 协商还款申请
export function* submitRepayment(action) {
  try {
    const { path, params } = action;

    const res = yield call(api.submitRepayment, path, { ...params, annexes: params.annexes?.map(i => i.name) });
    if (res.status === 0 || res.status === 2000) {
      if (res.resIds && res.resIds.length > 0) {
        let formData = new FormData();
        params.annexes.map((file, index) => {
          formData.append(res.resIds[index], file);
        });
        const response = yield call(api.uploadAnnexes, path, formData)
        if (response.status === 0 || response.status === 2000) {
          message.success(response.des);
        } else {
          message.error(response.des)
        }
      } else {
        yield put({ type: 'HIDE_LOADING' })
        message.success(res.des)
      }
      const { cb = window.noop } = action
      yield call(cb);
      // yield put({ type: 'HIDE_LOADING' })
      // message.success(result.des);
    } else {
      yield put({ type: 'HIDE_LOADING' })
      message.error(res.des)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* submitRepaymentRequest() {
  yield takeLatest(Type.SUBMIT_NEGREPAY, submitRepayment)
}

//获取电话
export function* getPhoneNumber(action) {
  try {
    const res = yield call(api.getPhoneNumber, action.path, action.systemNum);
    if (res) {
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb, res?.numberList);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* getPhoneNumberRequest() {
  yield takeLatest(Type.GET_PHONENUMBER, getPhoneNumber)
}

//调解登记修改
export function* mediationTime(action) {
  try {
    const res = yield call(api.mediationTime, action.params, action.path);
    if (res) {
      const { cb = window.noop } = action
      yield call(cb, res);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* mediationTimeRequest() {
  yield takeLatest(Type.MEDIATIONTIME, mediationTime)
}

//调解登记新增
export function* mediationRegister(action) {
  const { params, file } = action
  try {
    const res = yield call(api.mediationRegister, { ...params, record: file.name }, action.path);
    if (res.status === 2000) {
      if (res.data.status === 0) {
        const { cb = window.noop } = action
        yield put({ type: 'HIDE_LOADING' })
        yield call(cb);
      } else {
        let file = new FormData();
        file.append(res.data.resId, file);
        const fileUp = yield call(api.uploadMediationRecord, file, action.path);
        if (fileUp) {
          const { cb = window.noop } = action
          yield put({ type: 'HIDE_LOADING' })
          yield call(cb);
        }
      }

    } else {
      yield put({ type: 'HIDE_LOADING' })
      message.error(res.des)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* mediationRegisterRequest() {
  yield takeLatest(Type.GET_MEDIATIONREGISTER, mediationRegister)
}

//调解登记修改
export function* mediationRegisterUpdate(action) {
  const { params, file } = action
  try {
    const res = yield call(api.mediationRegisterUpdate, { ...params, record: file?.name, url: file?.url }, action.path);
    if (res.status === 2000) {
      if (res.data.status === 0) {
        const { cb = window.noop } = action
        yield put({ type: 'HIDE_LOADING' })
        yield call(cb);
      } else {
        let file = new FormData();
        file.append(res.data.resId, file);
        const fileUp = yield call(api.uploadMediationRecord, file, action.path);
        if (fileUp) {
          const { cb = window.noop } = action
          yield put({ type: 'HIDE_LOADING' })
          yield call(cb);
        }
      }
    } else {
      yield put({ type: 'HIDE_LOADING' })
      message.error(res.des)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* mediationRegisterUpdateRequest() {
  yield takeLatest(Type.GET_MEDIATIONREGISTERUPDATE, mediationRegisterUpdate)
}

//拨打电话
export function* callDefendant(action) {
  try {
    const res = yield call(api.callDefendant, action.params, action.path)
    if (res.status === 2000) {
      const { cb = window.noop } = action
      yield call(cb, res.data);
    } else {
      message.error(res.message)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* callDefendantRequest() {
  yield takeLatest(Type.CALL_DEFENDANT, callDefendant)
}

export function* getCallType(action) {
  try {
    const res = yield call(api.getCallType, action.path);

    if (res.status === 2000) {

      yield put({ type: Type.SET_CALLTYPE, callType: res.provider ?? "weygo" })
    } else {
      message.error(res.message)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* getCallTypeRequest() {
  yield takeLatest(Type.GET_CALLTYPE, getCallType)
}

//发送闪信
export function* sendFlashLetter(action) {
  try {
    const { status, data } = yield call(api.sendFlashLetter, action.payload, action.path)
    if (status === 2000) {
      if (data.processresult[0].status === '4') {
        message.success(data.processresult[0].msg)
      } else {
        message.error("闪信投递失败")
      }
    } else {
      message.error("闪信投递失败")
    }
  } catch (e) {
    message.info("闪信投递失败")
  }
}

export function* sendFlashLetterRequest() {
  yield takeLatest(Type.SEND_FLASHLETTER, sendFlashLetter)
}

export function* sendMsg(action) {
  try {
    const res = yield call(api.sendMsg, action.path, action.params, action.systemNum);
    if (res.status === 2000) {
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb);
    } else {
      yield put({ type: 'HIDE_LOADING' })
      message.error(res?.des)
    }
  } catch (error) {
    console.error(error)
  }
}

export function* sendMsgRequest() {
  yield takeLatest(Type.POST_SENDMSG, sendMsg)
}

export function* getMediationDoc(action) {
  try {
    const res = yield call(api.getDocCheckInfo, action.path, action.systemNum);
    const { cb = window.noop } = action
    yield put({ type: 'HIDE_LOADING' })
    yield call(cb, res);
  } catch (error) {
    console.error(error)
  }
}

export function* getMediationDocRequest() {
  yield takeLatest(Type.GET_MEDIATION_DOC, getMediationDoc)
}

export function* sendMediationDoc(action) {
  try {
    const res = yield call(api.sendMediationDoc, action.path, action.params);
    if (res.status === 2000) {
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb);
      message.success(res.des)
    } else {
      yield put({ type: 'HIDE_LOADING' })
      message.error(res.des)
    }

  } catch (error) {
    console.error(error)
  }
}

export function* sendMediationDocRequest() {
  yield takeLatest(Type.POST_MEDIATION_DOC, sendMediationDoc)
}

//电子卷宗
export function* dzjzUpload(action) {
  try {
    const res = yield call(api.getId, action.params, action.path, action.systemNum);
    if (res.status === 0) {
      let file = new FormData();
      file.append('file', action.params.file)
      const resT = yield call(api.fileUpload, file, action.path, res.resId);
      if (resT) {
        const { cb = window.noop } = action
        yield put({ type: 'HIDE_LOADING' })
        yield call(cb);
      } else {
        const { cbError = window.noop } = action
        yield call(cbError);
      }

    } else {
      const { cbCf = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cbCf);
    }
  } catch (error) {
    const { cbError = window.noop } = action
    yield call(cbError);
  }
}

export function* dzjzUploadRequest() {
  yield takeLatest(Type.GET_DZJZUPLOAD, dzjzUpload)
}


//签名
export function* getSignature(action) {
  try {
    const { systemNum, resID, sign, cb } = action;
    const res = yield call(api.getSignature, { systemNum, sign, resID });
    switch (res.status) {
      case 0:
        yield put({ type: 'HIDE_LOADING' });
        message.success(res.des);
        break;
      case 1:
        yield put({ type: 'HIDE_LOADING' });
        yield call(cb);
        message.error(res.des);
        break;
      default:
        yield put({ type: 'HIDE_LOADING' });
        message.error(res.des);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* getSignatureRequest() {
  yield takeLatest(Type.GET_SIGNATURE, getSignature)
}

//获取自动协查来源
export function* getLostProviderTypeDict(action) {
  Logs.debug('action',action)
  const {payload} = action

  const {path,systemNum} = payload

  try {
    const res = yield call(api.getLostProviderTypeDict,path);
    yield put({
      type:'HIDE_LOADING'
    })
    if(res) {
      if(!!systemNum) {
        yield put({
          type:Type.SET_LOSTPROVIDERTYPEDICT,
          payload:res,
          systemNum
        })
      }else {
        yield put({
          type:Type.SET_LOSTPROVIDERTYPEDICTCASEPOOL,
          payload:res,
        })
      }

    }
  }catch (error) {
    console.error(error)
  }
}

export function* getLostProviderTypeDictRequest() {
  yield takeLatest(Type.GET_LOSTPROVIDERTYPEDICT,getLostProviderTypeDict)
}
